import script from "./InviteModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./InviteModal.vue?vue&type=script&lang=ts&setup=true"

import "./InviteModal.vue?vue&type=style&index=0&id=19d62490&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19d62490"]])

export default __exports__